import React, { useCallback, useEffect, useRef, useState } from "react";
import { Empty, Spin } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { addReminder } from "../../../../store/chats/thunks";
import { scrollToBottom } from "../../../../utils/uiElementScroll";
import dayjs from "../../../../utils/dayjs";
import CustomCollapse from "../../../../components/generic/CustomDetails";
import AddReminderModal from "./AddReminder";
import { useReminders } from "../../../../hooks/useReminders";

const Reminders = () => {
  const [submitting, setSubmitting] = useState(false);
  const [selectedReminder, setSelectedReminder] = useState(null);

  const reminderBodyRef = useRef(null);

  const dispatch = useDispatch();

  const { reminders, loading, selectedTenantId, selectedChatId } =
    useReminders();

  const onAddReminder = useCallback(
    async (values) => {
      try {
        setSubmitting(true);
        await dispatch(
          addReminder({
            conversation_id: selectedChatId,
            tenant_id: selectedTenantId,
            ...values,
          }),
        );
        setSelectedReminder(null);
        scrollToBottom(reminderBodyRef);
      } finally {
        setSubmitting(false);
      }
    },
    [selectedChatId, selectedTenantId],
  );

  useEffect(() => {
    if (selectedChatId && !loading) scrollToBottom(reminderBodyRef);
  }, [loading, selectedChatId]);

  return (
    <>
      <CustomCollapse
        className="reminders-div productivity-padding"
        title="Reminders"
        //@ts-ignore
        headerRight={
          <span
            onClick={(e) => {
              e.preventDefault();
              setSelectedReminder({});
            }}
          >
            <PlusOutlined />
          </span>
        }
        open
      >
        <div className="reminders-body" ref={reminderBodyRef}>
          {loading ? (
            <div
              className="flex justify-center h-100 w-100 align-center"
              style={{
                marginTop: "10px",
              }}
            >
              <Spin />
            </div>
          ) : reminders?.length ? (
            reminders.map((r) => (
              <div
                key={r?.id}
                className="reminder-item cursor-pointer"
                onClick={() => setSelectedReminder(r)}
              >
                <div className="reminder-title">{r.title}</div>
                <div className="reminder-date">
                  {dayjs(r?.due_time).format("DD-MM-YYYY, hh:mm A")}
                </div>
              </div>
            ))
          ) : (
            <div className="flex justify-center h-100 w-100 align-center">
              <Empty
                description="No Reminders Found"
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            </div>
          )}
        </div>
      </CustomCollapse>
      {selectedReminder && (
        <AddReminderModal
          isProcessing={submitting}
          onCancel={() => setSelectedReminder(null)}
          onAdd={onAddReminder}
          selectedReminder={selectedReminder}
        />
      )}
    </>
  );
};

export default Reminders;
